export default "__VITE_ASSET__B7ffr3DK__"